import MKBox from 'components/MaterialKit/MKBox';
import Image from 'components/Image';
import MKTypography from 'components/MaterialKit/MKTypography';
import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

const BuddhistPageFooterSection = ({
  banner_image,
  column_1_text_1,
  column_1_text_1_clickable,
  column_1_text_1_url,
  column_1_text_2,
  column_1_text_2_clickable,
  column_1_text_2_url,
  column_2_title,
  column_2_text_1,
  column_2_text_1_clickable,
  column_2_text_1_url,
  column_2_text_2,
  column_2_text_2_clickable,
  column_2_text_2_url,
  column_2_text_3,
  column_2_text_3_clickable,
  column_2_text_3_url,
  column_2_text_4,
  column_2_text_4_clickable,
  column_2_text_4_url,
  column_3_text_1,
  column_3_text_1_clickable,
  column_3_text_1_url,
  column_3_text_2,
  column_3_text_2_clickable,
  column_3_text_2_url,
  column_3_icon_1,
  column_3_icon_1_clickable,
  column_3_icon_1_url,
  column_3_icon_1_width,
  column_3_icon_2,
  column_3_icon_2_clickable,
  column_3_icon_2_url,
  column_3_icon_2_width,
  font_color,
  font_size,
  title_font_color,
  title_font_size,
  on_click_color,
  background_color,
  ...props
}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const mobileMediaQuery = window.matchMedia('(max-width: 768px)');
    const handleMobileChange = (event) => {
      setIsMobile(event.matches);
    };
    mobileMediaQuery.addEventListener('change', handleMobileChange);
    setIsMobile(mobileMediaQuery.matches);
    return () => {
      mobileMediaQuery.removeEventListener('change', handleMobileChange);
    };
  }, []);

  return (
    <MKBox
      py={2}
      px={4}
      component="footer"
      bgColor={background_color}
      display="flex"
      flexDirection={isMobile ? 'column' : 'row'}
      justifyContent="space-evenly"
      {...props}
    >
      <MKBox mb="1rem">
        <Image src={banner_image} />
        <MKTypography color={location.pathname === column_1_text_1_url ? on_click_color : font_color} fontSize={font_size} style={{ cursor: column_1_text_1_clickable && 'pointer' }} onClick={() => column_1_text_1_clickable && column_1_text_1_url && navigate(column_1_text_1_url)}>
          {column_1_text_1}
        </MKTypography>
        <MKTypography color={location.pathname === column_1_text_2_url ? on_click_color : font_color} fontSize={font_size} style={{ cursor: column_1_text_2_clickable && 'pointer' }} onClick={() => column_1_text_2_clickable && column_1_text_2_url && navigate(column_1_text_2_url)}>
          {column_1_text_2}
        </MKTypography>
      </MKBox>
      <MKBox mb="1rem">
        <MKTypography color={title_font_color} fontSize={title_font_size} mb={1}>
          {column_2_title}
        </MKTypography>
        <MKTypography color={location.pathname === column_2_text_1_url ? on_click_color : font_color} fontSize={font_size} style={{ cursor: column_2_text_1_clickable && 'pointer' }} onClick={() => column_2_text_1_clickable && column_2_text_1_url && navigate(column_2_text_1_url)}>
          {column_2_text_1}
        </MKTypography>
        <MKTypography color={location.pathname === column_2_text_2_url ? on_click_color : font_color} fontSize={font_size} style={{ cursor: column_2_text_2_clickable && 'pointer' }} onClick={() => column_2_text_2_clickable && column_2_text_2_url && navigate(column_2_text_2_url)}>
          {column_2_text_2}
        </MKTypography>
        <MKTypography color={location.pathname === column_2_text_3_url ? on_click_color : font_color} fontSize={font_size} style={{ cursor: column_2_text_3_clickable && 'pointer' }} onClick={() => column_2_text_3_clickable && column_2_text_3_url && navigate(column_2_text_3_url)}>
          {column_2_text_3}
        </MKTypography>
        <MKTypography color={location.pathname === column_2_text_4_url ? on_click_color : font_color} fontSize={font_size} style={{ cursor: column_2_text_4_clickable && 'pointer' }} onClick={() => column_2_text_4_clickable && column_2_text_4_url && navigate(column_2_text_4_url)}>
          {column_2_text_4}
        </MKTypography>
      </MKBox>
      <MKBox mb="1rem">
        <MKBox display="flex" flexDirection="row" mb="0.5rem">
          <Image src={column_3_icon_1} width={column_3_icon_1_width} style={{ cursor: column_3_icon_1_clickable && 'pointer', marginRight: '1rem' }} onClick={() => column_3_icon_1_clickable && column_3_icon_1_url && navigate(column_3_icon_1_url)} />
          <Image src={column_3_icon_2} width={column_3_icon_2_width} style={{ cursor: column_3_text_2_clickable && 'pointer' }} onClick={() => column_3_icon_2_clickable && column_3_icon_2_url && navigate(column_3_icon_2_url)} />
        </MKBox>
        <MKTypography color={location.pathname === column_3_text_1_url ? on_click_color : font_color} fontSize={font_size} style={{ cursor: column_3_text_1_clickable && 'pointer' }} onClick={() => column_3_text_1_clickable && column_3_text_1_url && navigate(column_3_text_1_url)}>
          {column_3_text_1}
        </MKTypography>
        <MKTypography color={location.pathname === column_3_text_1_url ? on_click_color : font_color} fontSize={font_size} style={{ cursor: column_3_text_2_clickable && 'pointer' }} onClick={() => column_3_text_2_clickable && column_3_text_2_url && navigate(column_3_text_2_url)}>
          {column_3_text_2}
        </MKTypography>
      </MKBox>
    </MKBox>
  );
};

BuddhistPageFooterSection.propTypes = {
  banner_image: PropTypes.string,
  column_1_text_1: PropTypes.string,
  column_1_text_1_clickable: PropTypes.bool,
  column_1_text_1_url: PropTypes.string,
  column_1_text_2: PropTypes.string,
  column_1_text_2_clickable: PropTypes.bool,
  column_1_text_2_url: PropTypes.string,
  column_2_title: PropTypes.string,
  column_2_text_1: PropTypes.string,
  column_2_text_1_clickable: PropTypes.bool,
  column_2_text_1_url: PropTypes.string,
  column_2_text_2: PropTypes.string,
  column_2_text_2_clickable: PropTypes.bool,
  column_2_text_2_url: PropTypes.string,
  column_2_text_3: PropTypes.string,
  column_2_text_3_clickable: PropTypes.bool,
  column_2_text_3_url: PropTypes.string,
  column_2_text_4: PropTypes.string,
  column_2_text_4_clickable: PropTypes.bool,
  column_2_text_4_url: PropTypes.string,
  column_3_text_1: PropTypes.string,
  column_3_text_1_clickable: PropTypes.bool,
  column_3_text_1_url: PropTypes.string,
  column_3_text_2: PropTypes.string,
  column_3_text_2_clickable: PropTypes.bool,
  column_3_text_2_url: PropTypes.string,
  column_3_icon_1: PropTypes.string,
  column_3_icon_1_clickable: PropTypes.bool,
  column_3_icon_1_url: PropTypes.string,
  column_3_icon_1_width: PropTypes.string,
  column_3_icon_2: PropTypes.string,
  column_3_icon_2_clickable: PropTypes.bool,
  column_3_icon_2_url: PropTypes.string,
  column_3_icon_2_width: PropTypes.string,
  font_color: PropTypes.string,
  font_size: PropTypes.string,
  title_font_color: PropTypes.string,
  title_font_size: PropTypes.string,
  on_click_color: PropTypes.string,
  background_color: PropTypes.string,
};

export default BuddhistPageFooterSection;
